<template>
  <v-card flat color="transparent">
    <v-card-title class="headline"
      >Olá, <b class="ml-1">{{ usuarioLogado.nome }}</b></v-card-title
    >
    <v-card-text class="mt-2">
      <alerta-pedidos-sync />
      <atalhos-iniciais />
    </v-card-text>
  </v-card>
</template>

<script>
import AtalhosIniciais from "@/components/home/AtalhosIniciais.vue";
import { mapState } from "vuex";
import AlertaPedidosSync from '@/components/home/AlertaPedidosSync.vue';

export default {
  name: "HomeView",
  components: {
    AtalhosIniciais,
    AlertaPedidosSync,
  },
  computed: mapState("usuario", ["usuarioLogado"]),
  methods: {
    msgBoasVindas() {
      return `<span>Olá, <span class="title font-weight-bold">${this.usuarioLogado.nome}</span> </span>`;
    },
  },
};
</script>
